import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import { RTKQueryTag } from 'src/common/constants';

import { SinglePathData } from './path-outline.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSinglePathOutline: builder.query<ApiResponse<SinglePathData>, string>({
      query: (pathCode) => ({
        method: 'GET',
        url: `path/outline?pathCode=${pathCode}`,
      }),
      providesTags: [RTKQueryTag.PathOutline],
      onQueryStarted: async (arg, { queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (error) {
          const notFoundError = (error as { error: { status: number } }).error.status === 404;
          if (notFoundError) window.location.replace('/r/404');
        }
      },
    }),
    enrollInPath: builder.mutation<ApiResponse, string>({
      query: (pathCode) => ({
        method: 'PUT',
        url: `path/enroll?pathCode=${pathCode}`,
      }),
      invalidatesTags: [
        RTKQueryTag.PathOutline, // Refresh /path/outline page
        RTKQueryTag.PathProgress, // Refresh /path/outline progress
        RTKQueryTag.PathCurrent, // Refresh /paths page
        RTKQueryTag.LearnHacktivities, // Refresh /hacktivities > "Learning Paths" tab
        RTKQueryTag.User, // Refresh /hacktivities > "Learning Paths" tab
        RTKQueryTag.PathsCurrentModule, // Refresh /dashboard > Current tab
      ],
    }),
  }),
});

export const { useGetSinglePathOutlineQuery, useEnrollInPathMutation } = extendedApiSlice;
